const openClearCashReducers = (state = false, action) => {
  switch (action.type) {
    case "openClearCash":
      return (state = true);
    case "closeClearCash":
      return (state = false);
    default:
      return state;
  }
};
export default openClearCashReducers;
